import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import store from '@/store/store';

export default async function getAgenceId() {
  await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key]);
  const parametresInterne = store.getters['parametres/parametresInterne'];

  if (parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key)) {
    const agencesActive = store.getters['societe/agenceActive'];
    return agencesActive.map(agence => agence.agenceId);
  }
  return [];
}
